import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sp-custom-number-input',
    templateUrl: './custom-number-input.component.html',
    styleUrls: ['./custom-number-input.component.scss'],
})
export class CustomNumberInputComponent {
    @Input() minValue: number = 1;
    @Input() maxValue: number = 9999;
    @Input() value: number;
    @Output() valueUpdateEvent = new EventEmitter<number>();

    constructor() {}

    ngOnInit(): void {}

    onValueChange(event: any) {
        let input: number = event.target.value;
        if (input >= this.minValue && input <= this.maxValue) {
            this.value = input;
            this.valueUpdateEvent.emit(this.value);
        }
    }
    decreaseValue(): void {
        let input = Math.max(1, this.value - 1);
        if (input >= this.minValue) {
            this.value = input;
            this.valueUpdateEvent.emit(this.value);
        }
    }

    increaseValue(): void {
        this.value++;
        if (this.value <= this.maxValue) this.valueUpdateEvent.emit(this.value);
    }
}
